// extracted by mini-css-extract-plugin
export default {"placeholder":"placeholder_placeholder__kSmFQ","animatedBackground":"placeholder_animatedBackground__jnUUF"};